export class MenuConfig {
  public defaults: any = {
    aside: [
      {
        title: 'Dashboard',
        root: true,
        page: '/dashboard',
        translate: 'MENU.DASHBOARD',
      },
      {
        section: 'Member',
        translate: 'MENU.SECTION.MEMBER',
      },
      {
        title: 'Member',
        root: true,
        translate: 'MENU.MEMBER.TITLE',
        submenu: [
          {
            title: 'Agent Infomartion',
            page: '/member-information/agent-information',
            translate: 'MENU.MEMBER.AGENT_INFORMATION',
          },
          {
            title: 'Farm Infomartion',
            page: '/member-information/farm-information',
            translate: 'MENU.MEMBER.FARM_INFORMATION',
          },
           {
            title: 'Messages',
            page: '/member-information/message',
            translate: 'MENU.MEMBER.MESSAGING',
          },
        ],
      },
      {
        section: 'Raw Material',
        translate: 'MENU.SECTION.RAW_MATERIAL',
      },
      {
        title: 'Raw Material',
        root: true,
        translate: 'MENU.RAW_MATERIAL.SUB_TITLE_ONE',
        submenu: [
          {
            title: 'Pre Order',
            page: '/raw-material/pre-order',
            translate: 'MENU.RAW_MATERIAL.PRE_ORDER',
          },
          {
            title: 'Purchase Order',
            page: '/raw-material/purchase-order',
            translate: 'MENU.RAW_MATERIAL.PURCHASE_ORDER',
          },
          {
            title: 'Raw Material Receiving',
            page: '/raw-material/raw-material-receiving',
            translate: 'MENU.RAW_MATERIAL.RAW_MATERIAL_RECEIVING',
          },
          {
            title: 'Return Order',
            page: '/raw-material/return-order',
            translate: 'MENU.RAW_MATERIAL.RETURN_ORDER',
          },
          {
            title: 'Raw Material Buy',
            page: '/raw-material/raw-material-buy',
            translate: 'MENU.RAW_MATERIAL.RAW_MATERIAL_BUY',
          },
        ]
      },
      {
        title: 'Raw Material',
        root: true,
        translate: 'MENU.RAW_MATERIAL.SUB_TITLE_TWO',
        submenu: [
          {
            title: 'Raw Material Bid',
            page: '/raw-material/raw-material-bid',
            translate: 'MENU.RAW_MATERIAL.RAW_MATERIAL_BID',
          },
          {
            title: 'Raw Material Deposit',
            page: '/raw-material/raw-material-deposit',
            translate: 'MENU.RAW_MATERIAL.RAW_MATERIAL_DEPOSIT',
          },
          {
            title: 'Raw Material Sell',
            page: '/raw-material/raw-material-sell',
            translate: 'MENU.RAW_MATERIAL.RAW_MATERIAL_SELL',
          },
          {
            title: 'Send Order',
            page: '/raw-material/send-order',
            translate: 'MENU.RAW_MATERIAL.SEND_ORDER',
          },
          {
            title: 'Other Income Information',
            page: '/account-setting/other-income',
            translate: 'MENU.ACCOUNT_SETTING.OTHER_INCOME',
          },
          {
            title: 'Raw Material Receive Claim',
            page: '/raw-material/raw-material-receive-claim',
            translate: 'MENU.RAW_MATERIAL.RAW_MATERIAL_RECEIVE_CLAIM',
          },
          {
            title: 'Raw Material Send Claim',
            page: '/raw-material/raw-material-send-claim',
            translate: 'MENU.RAW_MATERIAL.RAW_MATERIAL_SEND_CLAIM',
          },
        ]
      },
      {
        title: 'Raw Material',
        root: true,
        translate: 'MENU.RAW_MATERIAL.SUB_TITLE_THREE',
        submenu: [
          {
            title: 'Raw Material Requisition',
            page: '/raw-material/raw-material-requisition',
            translate: 'MENU.RAW_MATERIAL.RAW_MATERIAL_REQUISITION',
          },
          {
            title: 'Transfer Setting',
            page: '/setting/pos-setting/transfer-setting',
            translate: 'MENU.SETTING.POS_SETTING.TRANSFER_SETTING',
          },
          {
            title: 'Stock Asjustment',
            page: '/raw-material/stock-adjust',
            translate: 'MENU.RAW_MATERIAL.STOCK_ADJUST',
          },
        ]
      },
          // {
          //   title: 'Pre Order',
          //   page: '/raw-material/pre-order',
          //   translate: 'MENU.RAW_MATERIAL.PRE_ORDER',
          // },
          // {
          //   title: 'Raw Material Bid',
          //   page: '/raw-material/raw-material-bid',
          //   translate: 'MENU.RAW_MATERIAL.RAW_MATERIAL_BID',
          // },
          // {
          //   title: 'Return Order',
          //   page: '/raw-material/return-order',
          //   translate: 'MENU.RAW_MATERIAL.RETURN_ORDER',
          // },
          // {
          //   title: 'Purchase Order',
          //   page: '/raw-material/purchase-order',
          //   translate: 'MENU.RAW_MATERIAL.PURCHASE_ORDER',
          // },
          // {
          //   title: 'Raw Material Receiving',
          //   page: '/raw-material/raw-material-receiving',
          //   translate: 'MENU.RAW_MATERIAL.RAW_MATERIAL_RECEIVING',
          // },
          // {
          //   title: 'Raw Material Requisition',
          //   page: '/raw-material/raw-material-requisition',
          //   translate: 'MENU.RAW_MATERIAL.RAW_MATERIAL_REQUISITION',
          // },
          // {
          //   title: 'Raw Material Claim',
          //   page: '/raw-material/raw-material-claim',
          //   translate: 'MENU.RAW_MATERIAL.RAW_MATERIAL_CLAIM',
          // },
          // {
          //   title: 'Raw Material Return',
          //   page: '/raw-material/raw-material-return',
          //   translate: 'MENU.RAW_MATERIAL.RAW_MATERIAL_RETURN',
          // },
          // {
          //   title: 'Stock Asjustment',
          //   page: '/raw-material/stock-adjust',
          //   translate: 'MENU.RAW_MATERIAL.STOCK_ADJUST',
          // },
          // {
          //   title: 'Raw Material Sell',
          //   page: '/raw-material/raw-material-sell',
          //   translate: 'MENU.RAW_MATERIAL.RAW_MATERIAL_SELL',
          // },
          // {
          //   title: 'Raw Material Buy',
          //   page: '/raw-material/raw-material-buy',
          //   translate: 'MENU.RAW_MATERIAL.RAW_MATERIAL_BUY',
          // },
          // {
          //   title: 'Send Order',
          //   page: '/raw-material/send-order',
          //   translate: 'MENU.RAW_MATERIAL.SEND_ORDER',
          // },
          // {
          //   title: 'Raw Material Deposit',
          //   page: '/raw-material/raw-material-deposit',
          //   translate: 'MENU.RAW_MATERIAL.RAW_MATERIAL_DEPOSIT',
          // },
          // {
          //   title: 'Raw Material Receive Claim',
          //   page: '/raw-material/raw-material-receive-claim',
          //   translate: 'MENU.RAW_MATERIAL.RAW_MATERIAL_RECEIVE_CLAIM',
          // },
          // {
          //   title: 'Raw Material Send Claim',
          //   page: '/raw-material/raw-material-send-claim',
          //   translate: 'MENU.RAW_MATERIAL.RAW_MATERIAL_SEND_CLAIM',
          // },
          // {
          //   title: 'Other Income Information',
          //   page: '/account-setting/other-income',
          //   translate: 'MENU.ACCOUNT_SETTING.OTHER_INCOME',
          // },
          // {
          //   title: 'Transfer Setting',
          //   page: '/setting/pos-setting/transfer-setting',
          //   translate: 'MENU.SETTING.POS_SETTING.TRANSFER_SETTING',
          // },

      //   ],
      // },
      {
        section: 'Account',
        translate: 'MENU.SECTION.ACCOUNT',
      },
      {
        title: 'Account',
        root: true,
        translate: 'MENU.ACCOUNT_SETTING.TITLE',
        submenu: [
          {
            title: 'Expense Information',
            page: '/account-setting/expenses',
            translate: 'MENU.ACCOUNT_SETTING.EXPENSES',
          },
          {
            title: 'Account Receive Information',
            page: '/account-setting/accept-debt',
            translate: 'MENU.ACCOUNT_SETTING.ACCEPT_DEBT',
          },
          {
            title: 'Account Payable Information',
            page: '/account-setting/pay-off-debt',
            translate: 'MENU.ACCOUNT_SETTING.PAY_OFF_DEBT',
          },
          {
            title: 'Enployee Wages Information',
            page: '/account-setting/employee-wages',
            translate: 'MENU.ACCOUNT_SETTING.EMPLOYEE_WAGES',
          },
          {
            title: 'Member Dividend Payment Information',
            page: '/account-setting/member-dividend-payment',
            translate: 'MENU.ACCOUNT_SETTING.MEMBER_DIVIEND_PAYMENT',
          },
          {
            title: 'Reduce Debt',
            page: '/raw-material/raw-material-reduce-debt',
            translate: 'MENU.RAW_MATERIAL.REDUCE_DEBT',
          },
          {
            title: 'Add Debt',
            page: '/raw-material/raw-material-add-debt',
            translate: 'MENU.RAW_MATERIAL.ADD_DEBT',
          },


        ],
      },
      {
        section: 'Manage Farming',
        translate: 'MENU.SECTION.MANAGE_FARMING',
      },
      {
        title: 'Farming Type',
        root: true,
        translate: 'MENU.MANAGE_FARMING.FARMING_TYPE.TITLE',
        submenu: [
          {
            title: 'Activity Type',
            page: '/manage-farming/farming-type/activity-type',
            translate: 'MENU.MANAGE_FARMING.FARMING_TYPE.ACTIVITY_TYPE',
          },
          {
            title: 'Farming Activity',
            page: '/manage-farming/farming-type/farming-activity',
            translate: 'MENU.MANAGE_FARMING.FARMING_TYPE.FARMING_ACTIVITY',
          },
          {
            title: 'Farming type',
            page: '/manage-farming/farming-type/farming-type',
            translate: 'MENU.MANAGE_FARMING.FARMING_TYPE.FARMING_TYPE',
          },
          {
            title: 'Crop requirement',
            page: '/manage-farming/farming-type/crop-requirement',
            translate: 'MENU.MANAGE_FARMING.FARMING_TYPE.CROP_REQUIREMENT',
          },
        ],
      },
      {
        title: 'Farming Activity',
        root: true,
        page: '/manage-farming/farming-activity/activity-information',
        translate: 'MENU.MANAGE_FARMING.FARMING_TYPE.ACTIVITY',
      },
      {
        title: 'Production Plan',
        root: true,
        translate: 'MENU.MANAGE_FARMING.PRODUCTION_PLAN.TITLE',
        submenu: [
          {
            title: 'Order Plan',
            page: '/manage-farming/production-plan/order-plan',
            translate: 'MENU.MANAGE_FARMING.PRODUCTION_PLAN.ORDER_PLAN',
          },
          {
            title: 'Analyze Orders',
            page: '/manage-farming/production-plan/analyze-orders',
            translate: 'MENU.MANAGE_FARMING.PRODUCTION_PLAN.ANALYZE_ORDERS',
          },
          {
            title: 'Report Plan',
            page: '/manage-farming/production-plan/report-plan',
            translate: 'MENU.MANAGE_FARMING.PRODUCTION_PLAN.REPORT_PLAN',
          },
        ],
      },
      {
        title: 'Farming Information',
        root: true,
        translate: 'MENU.MANAGE_FARMING.FARMING_INFORMATION.TITLE',
        submenu: [
          {
            title: 'Farming Information',
            page: '/manage-farming/farming-information/farming-information',
            translate: 'MENU.MANAGE_FARMING.FARMING_INFORMATION.FARMING_INFORMATION',
          },
          {
            title: 'Expense Information',
            page: '/manage-farming/farming-information/expense-information',
            translate: 'MENU.MANAGE_FARMING.FARMING_INFORMATION.EXPENSE_INFORMATION',
          },
          {
            title: 'Environment Information',
            page: '/manage-farming/farming-information/environment-information',
            translate: 'MENU.MANAGE_FARMING.FARMING_INFORMATION.ENVIRONMENT_INFORMATION',
          },
          {
            title: 'Wasting Information',
            page: '/manage-farming/farming-information/wasting-information',
            translate: 'MENU.MANAGE_FARMING.FARMING_INFORMATION.WASTING_INFORMATION',
          },
          {
            title: 'Growth Information',
            page: '/manage-farming/farming-information/growth-information',
            translate: 'MENU.MANAGE_FARMING.FARMING_INFORMATION.GROWTH_INFORMATION',
          },
          {
            title: 'Havest Information',
            page: '/manage-farming/farming-information/harvest-information',
            translate: 'MENU.MANAGE_FARMING.FARMING_INFORMATION.HAVEST_INFORMATION',
          },
        ],
      },
      {
        section: 'Contract',
        translate: 'MENU.SECTION.CONTRACT',
      },
      {
        title: 'Contract',
        root: true,
        translate: 'MENU.CONTRACT_LOT.TITLE',
        submenu: [
          {
            title: 'Contract Information',
            page: '/contract-lot-management/contract-information',
            translate: 'MENU.CONTRACT_LOT.CONTRACT_INFORMATION',
          },
          {
            title: 'Lot Information',
            page: '/contract-lot-management/lot-information',
            translate: 'MENU.CONTRACT_LOT.LOT_INFORMATION',
          },
        ],
      },
      {
        section: 'Setting',
        translate: 'MENU.SECTION.SETTING',
      },
      {
        title: 'General Setting',
        root: true,
        translate: 'MENU.SETTING.GENERAL_SETTING.TITLE',
        submenu: [
          {
            title: 'General Information',
            page: '/setting/general-setting/general-information',
            // page: '/manage-farming/production-plan/order-plan',
            translate: 'MENU.SETTING.GENERAL_SETTING.GENERAL_INFORMATION',
          },
          {
            title: 'Customer Information',
            page: '/setting/general-setting/customer-information',
            // page: '/manage-farming/production-plan/analyze-orders',
            translate: 'MENU.SETTING.GENERAL_SETTING.CUSTOMER_INFORMATION',
          },
          {
            title: 'Supplier Information',
            page: '/setting/general-setting/dealer-information',
            // page: '/manage-farming/production-plan/report-plan',
            translate: 'MENU.SETTING.GENERAL_SETTING.SUPPLIER_INFORMATION',
          },
          {
            title: 'Bank Account Information',
            page: '/setting/general-setting/bank-account-information',
            translate: 'MENU.SETTING.GENERAL_SETTING.ACCOUNT_INFORMATION',
          },
          {
            title: 'Expense Information',
            page: '/setting/general-setting/config-expense',
            translate: 'MENU.SETTING.GENERAL_SETTING.EXPENSE_INFORMATION',
          },
          {
            title: 'Other Income',
            page: '/setting/general-setting/other-income',
            translate: 'MENU.SETTING.GENERAL_SETTING.OTHER_INCOME',
          },
          {
            title: 'Warehouse Setting',
            page: '/setting/pos-setting/warehouse-setting',
            translate: 'MENU.SETTING.POS_SETTING.WAREHOUSE_SETTING',
          },

        ],
      },
      {
        title: 'Staff Setting',
        root: true,
        translate: 'MENU.SETTING.STAFF_SETTING.TITLE',
        submenu: [
          {
            title: 'Staff Information',
            page: '/setting/employee-setting/employee-information',
            translate: 'MENU.SETTING.STAFF_SETTING.STAFF_INFORMATION',
          },
          {
            title: 'Permission',
            page: '/setting/employee-setting/permission',
            translate: 'MENU.SETTING.STAFF_SETTING.PERMISSION',
          },
          {
            title: 'Position',
            page: '/setting/employee-setting/position',
            translate: 'MENU.SETTING.STAFF_SETTING.POSITION',
          },
        ],
      },
      {
        title: 'Raw Material Setting',
        root: true,
        translate: 'MENU.SETTING.RAW_MATERIAL_SETTING.TITLE',
        submenu: [
          {
            title: 'Unit',
            page: '/setting/ingredient-product-setting/unit',
            translate: 'MENU.SETTING.RAW_MATERIAL_SETTING.UNIT',
          },
          {
            title: 'Raw Material Type',
            page: '/setting/ingredient-product-setting/ingredient-product-type',
            translate: 'MENU.SETTING.RAW_MATERIAL_SETTING.RAW_MATERIAL_TYPE',
          },
          {
            title: 'Raw Material List',
            page: '/setting/ingredient-product-setting/ingredient-product-list',
            translate: 'MENU.SETTING.RAW_MATERIAL_SETTING.RAW_MATERIAL_LIST',
          },
        ],
      },
      {
        title: 'Initial Setting',
        root: true,
        translate: 'MENU.SETTING.INITIAL_SETTING.TITLE',
        submenu: [
          {
            title: 'Initial Cash',
            page: '/setting/default-setting/cash-default',
            translate: 'MENU.SETTING.INITIAL_SETTING.INITIAL_CASH',
          },
          {
            title: 'Initial Raw Material',
            page: '/setting/default-setting/ingredient-product-default',
            translate: 'MENU.SETTING.INITIAL_SETTING.INITIAL_RAW_MATERIAL',
          },
        ],
      },
      {
        title: 'Shareholder Setting',
        root: true,
        translate: 'MENU.SETTING.SHAREHOLDER_SETTING.TITLE',
        submenu: [
          {
            title: 'Shareholder Infotmation',
            page: '/setting/partner-setting/membership-information',
            translate: 'MENU.SETTING.SHAREHOLDER_SETTING.SHAREHOLDER_INFORMATION',
          },
        ],
      },
      {
        title: 'Pos Setting',
        root: true,
        translate: 'MENU.SETTING.POS_SETTING.TITLE',
        submenu: [


          {
            title: 'Menu Setting',
            page: '/setting/pos-setting/menu-setting',
            translate: 'MENU.SETTING.POS_SETTING.MENU_SETTING',
          },
          {
            title: 'Category Setting',
            page: '/setting/pos-setting/category-setting',
            translate: 'MENU.SETTING.POS_SETTING.CATEGORY_SETTING',
          },
          {
            title: 'Rounding Off Setting',
            page: '/setting/pos-setting/rounding-off-setting',
            translate: 'MENU.SETTING.POS_SETTING.ROUNDING_OFF_SETTING',
          },
          {
            title: 'Cancellation Setting',
            page: '/setting/pos-setting/cancellation-setting',
            translate: 'MENU.SETTING.POS_SETTING.CANCELLATION_SETTING',
          },
          {
            title: 'Printer Setting',
            page: '/setting/pos-setting/printer-setting',
            translate: 'MENU.SETTING.POS_SETTING.PRINTER_SETTING',
          },
          {
            title: 'POS Setting',
            page: '/setting/pos-setting/pos-setting',
            translate: 'MENU.SETTING.POS_SETTING.POS_SETTING',
          },
          {
            title: 'Promotion Setting',
            page: '/setting/pos-setting/promotion-setting',
            translate: 'MENU.SETTING.POS_SETTING.PROMOTION_SETTING',
          },
        ],
      },
      {
        section: 'Report',
        translate: 'MENU.SECTION.REPORT',
      },
      {
        title: 'Production Efficiency Report',
        root: true,
        translate: 'MENU.REPORT.PRODUCTION_EFFICIENCY.TITLE',
        submenu: [
          {
            title: 'Product Cost Report',
            page: '/report/production-efficiency/product-cost',
            translate: 'MENU.REPORT.PRODUCTION_EFFICIENCY.PRODUCT_COST',
          },
          {
            title: 'Product Cost by Activity Type Report',
            page: '/report/production-efficiency/product-cost-activity-type',
            translate: 'MENU.REPORT.PRODUCTION_EFFICIENCY.PRODUCT_COST_ACTIVITY_TYPE',
          },
          {
            title: 'Feed & Fertilize & Drug Report',
            page: '/report/production-efficiency/feed-fertilize-drug',
            translate: 'MENU.REPORT.PRODUCTION_EFFICIENCY.FEED_FERTILIZE_DRUG',
          },
          {
            title: 'Growth Report',
            page: '/report/production-efficiency/growth-report',
            translate: 'MENU.REPORT.PRODUCTION_EFFICIENCY.GROWTH_REPORT',
          },
          {
            title: 'Product Quantity Report',
            page: '/report/production-efficiency/product-quantity',
            translate: 'MENU.REPORT.PRODUCTION_EFFICIENCY.PRODUCT_QUANTITY',
          },
          {
            title: 'Wasting Report',
            page: '/report/production-efficiency/wasting-report',
            translate: 'MENU.REPORT.PRODUCTION_EFFICIENCY.WASTING_REPORT',
          },

        ],
      },
      {
        title: 'Environment Report',
        root: true,
        translate: 'MENU.REPORT.ENVIRONMENT_REPORT.TITLE',
        submenu: [
          {
            title: 'Environment Value Report',
            page: '/report/environment-report/environment-value',
            translate: 'MENU.REPORT.ENVIRONMENT_REPORT.ENVIRONMENT_VALUE',
          },
        ],
      },
      {
        title: 'Purchase Report',
        root: true,
        translate: 'MENU.REPORT.PURCHASE_REPORT.TITLE',
        submenu: [
          {
            title: 'Purchase Product Report',
            page: '/report/purchase-report/purchase-product',
            translate: 'MENU.REPORT.PURCHASE_REPORT.PURCHASE_PRODUCT',
          },
          {
            title: 'Purchase Raw Material Report',
            page: '/report/purchase-report/purchase-raw-material',
            translate: 'MENU.REPORT.PURCHASE_REPORT.PURCHASE_RAW_MATERIAL',
          },
        ],
      },
      {
        title: 'Sales Report',
        root: true,
        translate: 'MENU.REPORT.SALES_REPORT.TITLE',
        submenu: [
          {
            title: 'Sales Product Report',
            page: '/report/sales-report/sales-product',
            translate: 'MENU.REPORT.SALES_REPORT.SALES_PRODUCT',
          },
          // {
          //   title: 'Sales Raw Material Report',
          //   page: '/report/sales-report/sales-raw-material',
          //   translate: 'MENU.REPORT.SALES_REPORT.SALES_RAW_MATERIAL',
          // },
        ],
      },
      {
        title: 'Warehouse Report',
        root: true,
        translate: 'MENU.REPORT.WAREHOUSE_REPORT.TITLE',
        submenu: [
          {
            title: 'Inventory Report',
            page: '/report/warehouse-report/inventory-report',
            translate: 'MENU.REPORT.WAREHOUSE_REPORT.INVENTORY_REPORT',
          },
          {
            title: 'Claim Report',
            page: '/report/warehouse-report/claim-report',
            translate: 'MENU.REPORT.WAREHOUSE_REPORT.CLAIM_REPORT',
          },
          {
            title: 'Return Report',
            page: '/report/warehouse-report/back-report',
            translate: 'MENU.REPORT.WAREHOUSE_REPORT.REPORT_BACK',
          },
        ],
      },
      {
        title: 'Accounting Report',
        root: true,
        translate: 'MENU.REPORT.ACCOUNTING_REPORT.TITLE',
        submenu: [
          {
            title: 'Income Statement Report',
            page: '/report/accounting-report/income-statement',
            translate: 'MENU.REPORT.ACCOUNTING_REPORT.INCOME_STATEMENT',
          },
          {
            title: 'Cash Flow Statement Report',
            page: '/report/accounting-report/cash-flow-statement',
            translate: 'MENU.REPORT.ACCOUNTING_REPORT.CASH_FLOW_STATEMENT',
          },
          {
            title: 'Debtor Report',
            page: '/report/accounting-report/debtor-report',
            translate: 'MENU.REPORT.ACCOUNTING_REPORT.DEBTOR_REPORT',
          },
          {
            title: 'Creditor Report',
            page: '/report/accounting-report/creditor-report',
            translate: 'MENU.REPORT.ACCOUNTING_REPORT.CREDITOR_REPORT',
          },
          {
            title: 'Expenses Report',
            page: '/report/accounting-report/expenses-report',
            translate: 'MENU.REPORT.ACCOUNTING_REPORT.EXPENSES_REPORT',
          },
          {
            title: 'Tax Report',
            page: '/report/general-report/tax-report',
            translate: 'MENU.REPORT.GENERAL_REPORT.TAX_REPORT',
          },
        ],
      },
      {
        title: 'General Report',
        root: true,
        translate: 'MENU.REPORT.GENERAL_REPORT.TITLE',
        submenu: [
          {
            title: 'Wage Report',
            page: '/report/general-report/wage-report',
            translate: 'MENU.REPORT.GENERAL_REPORT.WAGE_REPORT',
          },
          {
            title: 'Receive Money Report',
            page: '/report/general-report/receive-money-report',
            translate: 'MENU.REPORT.GENERAL_REPORT.RECEIVE_MONEY_REPORT',
          },
          {
            title: 'Close Lot Report',
            page: '/report/general-report/close-lot-report',
            translate: 'MENU.REPORT.GENERAL_REPORT.CLOSE_LOT_REPORT',
          },
          {
            title: 'Pay Dividends Report',
            page: '/report/general-report/pay-dividends-report',
            translate: 'MENU.REPORT.GENERAL_REPORT.PAY_DEVEDENDS_REPORT',
          },
          {
            title: 'Contract Report',
            page: '/report/general-report/contract-report',
            translate: 'MENU.REPORT.GENERAL_REPORT.CONTRACT_REPORT',
          },
        ],
      },
      {
        title: 'Analysis Report',
        root: true,
        translate: 'MENU.REPORT.ANALYSIS_REPORT.TITLE',
        submenu: [
          {
            title: 'Perormance Analysis Report',
            page: '/report/analysis-report/performance-analysis',
            translate: 'MENU.REPORT.ANALYSIS_REPORT.PERFORMANCE_ANALYSIS',
          },
          {
            title: 'Farming Report',
            page: '/report/analysis-report/farming-report',
            translate: 'MENU.REPORT.ANALYSIS_REPORT.FARMING_REPORT',
          },
          // {
          //   title: 'Purchase Raw Material Report',
          //   page: '/report/analysis-report/purchase-raw-material',
          //   translate: 'MENU.REPORT.ANALYSIS_REPORT.PURCHASE_RAW_MATERIAL',
          // },
          // {
          //   title: 'Product Truck Report',
          //   page: '/report/analysis-report/product-truck',
          //   translate: 'MENU.REPORT.ANALYSIS_REPORT.PRODUCT_TRUCK',
          // },
          {
            title: 'Raw Material Truck Report',
            page: '/report/analysis-report/raw-material-truck',
            translate: 'MENU.REPORT.ANALYSIS_REPORT.RAW_MATERIAL_TRUCK',
          },
          // {
          //   title: 'Feed & Fertilize Report',
          //   page: '/report/analysis-report/feed-fertilize',
          //   translate: 'MENU.REPORT.ANALYSIS_REPORT.FEED_FERTILIZE',
          // },
          {
            title: 'Harvest Report',
            page: '/report/analysis-report/harvest-report',
            translate: 'MENU.REPORT.ANALYSIS_REPORT.HARVEST_REPORT',
          },
          {
            title: 'Stock Adjusment Report',
            page: '/report/analysis-report/stock-adjustment',
            translate: 'MENU.REPORT.ANALYSIS_REPORT.STOCK_ADJUSTMENT',
          },
          {
            title: 'Cash Flow Management Report',
            page: '/report/analysis-report/cash-flow-management',
            translate: 'MENU.REPORT.ANALYSIS_REPORT.CASH_FLOW_MANAGEMENT',
          },
        ],
      },
    ]
  }

  public get configs(): any {
    return this.defaults;
  }
}
